function Toggle(switcher, target, toggle_switcher_class, toggle_target_class, target_is_child = false, target_is_sibling = false) {

    this.switchElSelector = switcher;
    this.targetElSelector = target;

    this.switchEl = document.querySelectorAll(switcher);
    this.targetEl;

    this.toggleSwitchElClass = toggle_switcher_class;
    this.toggleTargetElClass = toggle_target_class;

    if (this.targetElSelector) {
        if (!target_is_child && !target_is_sibling) {
            this.targetEl = document.querySelectorAll(target);
        }
    }

    if (this.switchEl) {
        this.init(target_is_child, target_is_sibling);
    }

}

Toggle.prototype.init = function (target_is_child, target_is_sibling) {

    var that = this;

    var switchEl,
        targetEl,
        childTargets,
        siblingTargets;

    for (var i = 0; i < this.switchEl.length; i++) {

        switchEl = this.switchEl[i];

        switchEl.addEventListener('click', function (event) {

            if ((target_is_child && event.target == this) || !target_is_child) {
                this.classList.toggle(that.toggleSwitchElClass);
            }

            if (that.targetElSelector) {
                if (that.targetEl && that.targetEl.length > 0) {
                    for (var k = 0; k < that.targetEl.length; k++) {
                        targetEl = that.targetEl[k];
                        targetEl.classList.toggle(that.toggleTargetElClass);
                    }
                }
                else {
                    if (target_is_child) {

                        childTargets = this.children;

                        if (event.target == this) {
                            for (var j = 0; j < childTargets.length; j++) {
                                targetEl = childTargets[j];
                                if (targetEl.matches(that.targetElSelector)) {
                                    targetEl.classList.toggle(that.toggleTargetElClass);
                                }
                            }
                        }

                    }
                    else if (target_is_sibling) {

                        siblingTargets = this.parentNode.querySelectorAll(that.targetElSelector);
                        for (var j = 0; j < siblingTargets.length; j++) {
                            targetEl = siblingTargets[j];
                            targetEl.classList.toggle(that.toggleTargetElClass);
                        }
                    }

                }
            }

        });

    }

}

export default Toggle;



// WEBPACK FOOTER //
// ./js/util/toggle.js